export const ConfigActionType = {
    ShippingMethod: '[Config] Shipping methods'
};